import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { services, serviceCategories } from '../data/mock';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon size={28} /> : <LucideIcons.FileText size={28} />;
  };

  return (
    <div>
      {/* Page Header */}
      <section className="bg-gradient-to-br from-emerald-800 to-emerald-900 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Our Services</h1>
            <p className="text-emerald-200 text-lg max-w-2xl mx-auto">
              Comprehensive financial, taxation, audit, and business advisory services to help your business thrive
            </p>
            <div className="flex items-center justify-center gap-2 mt-6 text-sm">
              <Link to="/" className="text-emerald-300 hover:text-white transition-colors">Home</Link>
              <span className="text-emerald-500">/</span>
              <span className="text-white">Services</span>
            </div>
          </div>
        </div>
      </section>

      {/* Services by Category */}
      {serviceCategories.map((category, catIndex) => {
        const categoryServices = services.filter(s => s.category === category);
        return (
          <section key={catIndex} className={`py-16 ${catIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
            <div className="container mx-auto px-4">
              <div className="mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{category}</h2>
                <div className="w-20 h-1 bg-emerald-600 rounded"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {categoryServices.map((service) => (
                  <Card key={service.id} className="group hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-emerald-200 hover:-translate-y-1">
                    <CardContent className="p-6">
                      <div className="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                        {getIcon(service.icon)}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-emerald-700 transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {service.description}
                      </p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </section>
        );
      })}

      {/* CTA */}
      <section className="py-16 bg-emerald-700">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Need Help Choosing the Right Service?</h2>
          <p className="text-emerald-200 mb-8 max-w-xl mx-auto">
            Our experts are here to guide you through the best options for your business needs.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-emerald-700 hover:bg-emerald-50">
              Contact Us Now
              <ArrowRight className="ml-2" size={18} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
